import React from 'react';
import ClientErrorPage from '../../../pages/errors/ClientError';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Mettre à jour l'état pour afficher l'UI de repli
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log des erreurs
        console.error('Error caught by boundary:', error, errorInfo);
    }

    render() {
        // if (this.state.hasError) {
        //     return <ClientErrorPage />;
        // }

        return this.props.children;
    }
}
